import { trackEvent } from './mixpanel'

export function trackPageViewed(pageName, extraProps = {}) {
    return trackEvent('page_viewed', {
        page_name: pageName,
        referrer: document.referrer || null,
        ...extraProps,
    })
}

export function trackCtaClicked(ctaLabel, extraProps = {}) {
    return trackEvent('cta_clicked', {
        cta_label: ctaLabel,
        ...extraProps,
    })
}

export function trackRegistrationStarted(extraProps = {}) {
    return trackEvent('registration_started', {
        ...extraProps,
    })
}

export function trackRegistrationCompleted(extraProps = {}) {
    return trackEvent('sign_up_completed', {
        ...extraProps,
    })
}
